import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import PayrollService from "./PayrollServices";
import { toast } from "react-toastify";
import { successAlert, toggleModal } from "../../Global/GlobalSlice";

export const getPayrollData = createAsyncThunk(
  "payroll/getPayrollData",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PayrollService.getPayrollData(data);

      if (responseData?.successful === true) {
        toast.success(responseData?.data?.statusMessage);
      }
      return responseData?.responseObject;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const schedulePayroll = createAsyncThunk(
  "Payroll/SchedulePayrollRunController",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PayrollService.schedulePayroll(data);

      console.log(responseData);
      if (responseData?.successful === true) {
        toast.success(responseData?.statusMessage);
      } else if (responseData?.statusMessage) {
        toast.error(responseData?.statusMessage);
      }
      toast.success(responseData?.statusMessage);
      return responseData?.data;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err?.response?.data);
    }
  }
);

export const initiatePayroll = createAsyncThunk(
  "payroll/initiatePayroll",
  async (batchID, { rejectWithValue }) => {
    try {
      const responseData = await PayrollService.initiatePayroll(batchID);
      if (responseData?.successful === true) {
        toast.success(responseData?.statusMessage);
      }
      return responseData?.data;
    } catch (err) {
      toast.error(err?.response?.data?.statusMessage);
      console.log(err);
      return rejectWithValue(err?.response?.data);
    }
  }
);

export const generateAllPayroll = createAsyncThunk(
  "payroll/generateAllPayroll",
  async (batchID, { rejectWithValue }) => {
    try {
      const responseData = await PayrollService.generateAllPayroll(batchID);
      if (responseData?.successful === true) {
        toast.success(responseData?.statusMessage);
      }
      return responseData?.data;
    } catch (err) {
      toast.error(err?.response?.data?.statusMessage);
      console.log(err);
      return rejectWithValue(err?.response?.data);
    }
  }
);

export const approvePayroll = createAsyncThunk(
  "payroll/approvedeclinepayrollrun",
  async (
    { payrollID, currentBatchStatus, currentApprovalStatus, employeeIdList },
    { rejectWithValue, getState, dispatch }
  ) => {
    toast.loading("Processing...");
    try {
      const responseData = await PayrollService.approvePayroll({
        payrollID,
        currentBatchStatus,
        currentApprovalStatus,
        employeeIdList,
      });
      if (responseData?.successful === true) {
        toast.dismiss();
        dispatch(
          successAlert({
            message: responseData?.statusMessage,
          })
        );
        dispatch(toggleModal("success"));
      } else if (responseData?.statusMessage) {
        toast.dismiss();
        toast(responseData?.statusMessage);
      }
      return responseData?.data;
    } catch (err) {
      toast.dismiss();
      toast.error(err?.response?.data?.statusMessage);
      console.log(err);
      return rejectWithValue(err?.response?.data);
    }
  }
);

export const getPayrollStaff = createAsyncThunk(
  "payroll/getPayrollStaff",
  async (params, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PayrollService?.getPayrollStaff(params);

      if (responseData?.successful === true) {
        toast(responseData?.data?.statusMessage);
      }
      return responseData?.responseObject;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getStaffComponent = createAsyncThunk(
  "payroll/getStaffComponent",
  async (params, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await PayrollService.getStaffComponent(params);

      if (responseData?.successful === true) {
      }
      return responseData?.responseObject;
    } catch (err) {
      console.log({ err });
      toast.error(err?.response?.data?.statusMessage);
      return rejectWithValue(err?.response?.data);
    }
  }
);

export const removeStaff = createAsyncThunk(
  "payroll/removeStaff",
  async (params, { rejectWithValue, getState, dispatch }) => {
    try {
      toast.loading("Processing...");
      const responseData = await PayrollService.removeStaff(params);

      if (responseData?.successful === true) {
        toast.dismiss();
        dispatch(
          successAlert({
            message: responseData?.statusMessage,
          })
        );
      }
      toast.dismiss();
      return responseData?.responseObject;
    } catch (err) {
      console.log({ err });
      toast.dismiss();
      toast.error(err?.response?.data?.statusMessage);
      return rejectWithValue(err?.response?.data);
    }
  }
);

const initialState = {
  payrollData: {},
  payrollStaffData: {},
  currentStaffData: {},
  isLoading: false,
  error: null,
  payrollAutoRUn: false,
};

const reducers = {
  viewPayroll(state, action) {
    return { ...state, data: action.payload };
  },
  PayrollRunning(state, action) {
    return { ...state, payrollAutoRun: action.payload };
  },
};

export const PayrollSlice = createSlice({
  name: "payroll",
  initialState,
  reducers,
  extraReducers: (builder) => {
    builder
      .addCase(getPayrollData.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getPayrollData.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          payrollData: action.payload,
        };
      })
      .addCase(getPayrollData.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(schedulePayroll.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(schedulePayroll.fulfilled, (state) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(schedulePayroll.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(initiatePayroll.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(initiatePayroll.fulfilled, (state) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(initiatePayroll.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(generateAllPayroll.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(generateAllPayroll.fulfilled, (state) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(generateAllPayroll.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(approvePayroll.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(approvePayroll.fulfilled, (state) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(approvePayroll.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(getPayrollStaff.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getPayrollStaff.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          payrollStaffData: action.payload,
        };
      })
      .addCase(getPayrollStaff.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(getStaffComponent.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getStaffComponent.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          currentStaffData: action.payload,
        };
      })
      .addCase(getStaffComponent.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(removeStaff.pending, (state) => {
        return { ...state, isLoading: true };
      })
      .addCase(removeStaff.fulfilled, (state) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(removeStaff.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      })
      .addCase(PayrollSlice.actions.PayrollRunning, (state, action) => {
        return {
          ...state,
          payrollAutoRun: action.payload,
        };
      });
  },
});

export const { viewPayroll, PayrollRunning } = PayrollSlice.actions;

export default PayrollSlice.reducer;
